import Model from '@/models/Model'

export default class SlWholesaleDiscountSubfamily extends Model {
    resource() {
        return 'sl_wholesale_discount_subfamily'
    }
}